import { Button } from "@heroui/react";
import type { AdminProductionProgress } from "@storyline/shared";
import { type AdminEpisodeDetail, ProductionState, StoryStatus } from "@storyline/shared";
import { useRef } from "react";
import SectionCard from "@/src/common/components/section-card";
import CostProgressBanner from "@/src/stories/components/cost-progress-banner";

type PublishPanelProps = {
	episode: AdminEpisodeDetail;
	production: AdminProductionProgress;
	onPublish: () => void;
	onUnpublish: () => void;
	onTransition: (to: ProductionState) => void;
	onUploadCover: (file: File) => void;
};

const PublishPanel: React.FC<PublishPanelProps> = ({ episode, production, onPublish, onUnpublish, onTransition, onUploadCover }) => {
	const coverInputRef = useRef<HTMLInputElement>(null);
	const isPublished = episode.status === StoryStatus.PUBLISHED;

	return (
		<div className="flex flex-col gap-4">
			<CostProgressBanner production={production} />
			<SectionCard
				title="Publication"
				description="Toutes les frames sont rendues. Une dernière re-validation du graphe est faite à la publication."
			>
				<div className="flex flex-wrap items-center gap-4">
					<div className="flex aspect-video w-56 items-center justify-center overflow-hidden rounded-lg bg-glass">
						{episode.coverUrl ? (
							<img src={episode.coverUrl} alt="" className="size-full object-cover" />
						) : (
							<span className="text-muted text-xs">Sans couverture</span>
						)}
					</div>
					<div className="flex flex-col gap-2">
						<Button size="sm" variant="secondary" onPress={() => coverInputRef.current?.click()}>
							Uploader une couverture
						</Button>
						<input
							ref={coverInputRef}
							type="file"
							accept="image/*"
							className="hidden"
							onChange={(event) => {
								const file = event.target.files?.[0];
								if (file) {
									onUploadCover(file);
								}
							}}
						/>
					</div>
				</div>
				<div className="flex items-center justify-between gap-2">
					<Button variant="ghost" className="text-muted" onPress={() => onTransition(ProductionState.VIDEOS_REVIEW)}>
						← Revue des vidéos
					</Button>
					{isPublished ? (
						<Button variant="secondary" onPress={onUnpublish}>
							Dépublier
						</Button>
					) : (
						<Button onPress={onPublish}>Publier l'épisode</Button>
					)}
				</div>
			</SectionCard>
		</div>
	);
};

export default PublishPanel;
